import { Box } from "@mui/material";
import { Spinner } from "../spinner";

type LoadingProps = {
  centered?: boolean;
  size?: number;
};

export const Loading = ({ centered = false, size = 40 }: LoadingProps) => {
  if (centered) {
    return (
      <Box
        sx={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          height: "100%",
        }}
      >
        <Spinner size={size} />
      </Box>
    );
  }
  return (
    <Box
      sx={{
        position: "absolute",
        top: "50%",
        left: "50%",
      }}
    >
      <Spinner size={size} />
    </Box>
  );
};
